

export const wan = {
    tabs: { textToVideo: '文字轉影片', imageToVideo: '圖片轉影片' },
    upload: { addImage: '新增圖片', formats: 'JPG、PNG、WebP • 最大 10MB' },
    prompt: {
      label: '提示詞',
      placeholder: '描述你要生成的影片…',
      sub: '描述期望的運動與內容',
      count: '{count} / 800'
    },
    groups: {
      duration: '時長',
      resolution: '解析度',
      aspect: '畫面比例',
      aspectInfo: '輸出影片比例將與上傳圖片一致'
    },
    advanced: {
      title: '進階設定',
      negativePrompt: '反向提示',
      negativePlaceholder: '描述你不希望在影片中出現的內容…',
      negativeHelp: '可選：描述需要避免的內容',
      seed: '種子',
      seedPlaceholder: '隨機（留空）',
      seedHelp: '可選：指定種子以便重現結果'
    },
    credits: { bar: '積分消耗', value: '{value} 積分' },
    actions: { generate: '生成影片（{value} 積分）' },
    preview: { title: '準備就緒', desc: '配置設定後點擊生成，開始創作精彩影片' }
  };
